import React, { useEffect, useState } from "react";
import {
  TextField,
  InputAdornment,
  styled,
  Box,
  Typography,
} from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import VerifyOtp from "./VerifyOtp";
import InputField from "./InputField";
import { formatTime } from "../../utils/formatTime";
import { api, post } from "../../utils/api";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px",
  },
}));

const PhoneInput = ({
  title,
  value,
  fieldName,
  placeholder,
  element,
  countryCode,
  setFormData,
  formData,
  showIcon,
  setErrors,
  errors,
  verify,
  setVerify,
  verifybtn,
  setverifybtn,
  TaskAltIcons,
  setTaskAltIcons,
}) => {
  // console.log(verify,verifybtn,verify.phoneMsg,"for the phoneInput")
  const [otp, setOTP] = useState({
    phone: null,
  });

  const [timerPhone, setTimerPhone] = useState(120);
  const [timerActive, setTimerActive] = useState({
    phone: false,
  });

  useEffect(() => {
    if (timerActive.phone && timerPhone > 0) {
      const timer = setInterval(() => {
        setTimerPhone((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            setTimerActive((prev) => ({ ...prev, phone: false }));
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [timerActive.phone,timerPhone]); // Corrected dependency

  const handleInputChange = (event) => {
    const inputValue = event.target.value;

    // Allow only numeric input and restrict to 10 digits
    if (/^\d{0,10}$/.test(inputValue)) {
      handlePhoneChange(event);
    }
  };

  const handlePhoneChange = (e) => {
    const { value } = e.target;

    // Reset the icons and error state when phone changes
    setTaskAltIcons({ ...TaskAltIcons, phone: false });
    setVerify({ ...verify, phone: false, phoneMsg: "" });
    setverifybtn({ ...verifybtn, phone: false });
    setTimerPhone(120); // Reset timer
    setErrors((prevErrors) => ({
      ...prevErrors, // Preserve existing errors
      phone: "",
      contactPersonMobile: "",
    }));

    // Ensure country code is selected before validating the phone number
    if (formData?.countryCode === "") {
      setErrors((prevErrors) => ({
        ...prevErrors, // Preserve existing errors
        // phone: "Country Code is required. Please Select Country",
        phone: "Please Select Country",
        contactPersonMobile: "Please Select Country",
      }));
      return;
    }

    // Reset OTP field when phone number is updated
    setOTP((prevOtp) => ({
      ...prevOtp,
      phone: "", // Reset OTP value
    }));

    // Validate if the number is numeric and doesn't exceed 10 digits
    if (!/^\d{0,10}$/.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors, // Preserve existing errors
        phone: "Please Enter 0 - 9 digit only.", // Clear only the email error
        contactPersonMobile: "Please Enter 0 - 9 digit only.",
      }));
      return; // If the value is not numeric or exceeds 10 digits, do nothing
    }

    // Update formData only when phone number is valid
    setFormData((prevFormData) => ({
      ...prevFormData,
      phone: value, // Update the mobile number as a string
    }));

    if (value === element?.phone) {
      setTaskAltIcons({ ...TaskAltIcons, phone: true });
      return;
    }

    // Enable the verify button if phone number is exactly 10 digits
    if (value.length === 10) {
      setverifybtn({ ...verifybtn, phone: true });
    }
  };

  const handleVerifyPhone = async (timerPhone) => {
    if (timerPhone > 0) {
      setverifybtn((prev) => ({ ...prev, phone: false }));
      setTimerActive((prev) => ({ ...prev, phone: true })); // Start timer
      await post(`/auth/sendOtpToPhone`, {
        phone: formData.phone,
        countryCode: formData.countryCode,
        module: "Purchase",
      })
        .then((res) => {
          setVerify((prev) => ({ ...prev, phone: true, phoneMsg: "" }));
        })
        .catch((err) => {
          if (err.response.data.statusCode === false) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              phone: "Mobile Number already registered.",
              contactPersonMobile: "Mobile Number already registered.",
            }));
          }
        });
    } else {
      setVerify({ ...verify, phone: false });
      setverifybtn({ ...verifybtn, phone: false });
    }
  };

  const handleOTPVerifyPhone = async (e) => {
    // Defensive check to ensure e.target exists
    if (!e.target) return;

    const { value } = e.target;

    // Only allow numeric values and ensure length does not exceed 4
    const isNumeric = /^\d+$/.test(value) || value === ""; // Allow empty string to support deletion

    // Update state only if the value is numeric and has a length <= 4
    if (isNumeric && value.length <= 4) {
      setVerify({ ...verify, phoneMsg: "" });
      setOTP((prevOtp) => ({
        ...prevOtp,
        phone: value, // Update the OTP value
      }));
      // Trigger API call when exactly 4 digits are entered
      if (value.length > 4)
        setVerify({ ...verify, phoneMsg: "Enter 4 digit OTP" });
      if (value.length === 4) {
        await post(`/auth/verifyOtpForPhone`, {
          phone: formData?.phone,
          countryCode: formData?.countryCode,
          otp: value,
        })
          .then((res) => {
            // console.log("OTP verified successfully:", res, res.status);
            setVerify((prev) => ({ ...prev, phone: false, phoneMsg: "" }));
            setverifybtn((prev) => ({ ...prev, phone: false }));
            setTaskAltIcons((prev) => ({ ...prev, phone: true }));
              setErrors((prevErrors) => ({
                ...prevErrors, // Preserve existing errors
                phone: "", // Clear only the email error
                contactPersonMobile: "",
              }));

          })
          .catch((err) => {
            console.error("Error verifying OTP:", err);
            setVerify({ ...verify, phoneMsg: "Invalid OTP" });
            setTaskAltIcons({ ...TaskAltIcons, phone: false });
          });
      }
    }
  };

  const handleResendPhone = () => {
    setTimerPhone(120); // Reset time to 120 seconds
    setTimerActive((prev) => ({ ...prev, phone: true })); // Start the timer
    handleVerifyPhone(120); // Call the phone verification function
  };

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
        {title}
      </Typography>
      <CustomTextField
        variant="outlined"
        fullWidth
        value={value || ""}
        placeholder={placeholder}
        // disabled={!countryCode}
        onChange={handleInputChange} // Use the new input change handler
        InputProps={{
          maxLength: 10, // Visual limit
          inputMode: "numeric",
          pattern: "[0-9]*",
          endAdornment: showIcon && <TaskAltIcon sx={{ color: "green" }} />,
          startAdornment: (
            <InputAdornment
              position="start"
              sx={{ display: "flex", alignItems: "center" }}
            >
              {/* Render placeholder or countryCode */}
              {countryCode ? (
                <div
                  style={{
                    width: "40px",
                    marginRight: "8px",
                    fontWeight: "bold",
                  }}
                >
                  {countryCode}
                </div>
              ) : (
                <div
                  style={{
                    width: "40px",
                    marginRight: "8px",
                    color: "#B0B0B0",
                  }}
                >
                  {"code"}
                </div>
              )}
              {/* Vertical Line */}
              <div
                style={{
                  borderRight: "1px solid #000",
                  height: "24px",
                  marginRight: "8px",
                }}
              />
            </InputAdornment>
          ),
        }}
      />
      {errors && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}

      {verifybtn.phone && formData?.phone && (
        <VerifyOtp
          handleChange={() => handleVerifyPhone(120)}
          text={"Verify"}
        />
      )}
      {verify.phone && formData?.phone  && (
        <Box>
          <InputField
            value={otp.phone}
            title="Enter OTP For Phone"
            handleChange={handleOTPVerifyPhone}
            name="otpPhone"
            placeholder="Enter OTP"
            inputProps={{
              maxLength: 4,
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
          />
          <Typography variant="body2" color="#D34040">
            {verify.phoneMsg}
          </Typography>
          {timerActive.phone ? (
            <Box sx={{ textAlign: "right" }}>{formatTime(timerPhone)}</Box>
          ) : (
            <VerifyOtp handleChange={() => handleResendPhone()} text="Resend" />
          )}
        </Box>
      )}
    </Box>
  );
};

export default PhoneInput;
